import { css } from 'linaria';

export const root = css`
    display: flex;
    height: 48px;
    margin: 0;
    padding-left: 4px;
`;

export const orderedList = css`
    display: inline-flex;
    flex-wrap: nowrap;
    align-items: center;
    list-style: none;
    max-width: 100%;
    margin: 0;
    padding: 0;
`;

export const wrap = css`
    flex-wrap: wrap;
`;

export const overflowDetect = css`
    width: 1px;
    flex-shrink: 1;
`;
